import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig/authConfig';
import { PublicClientApplication } from "@azure/msal-browser";
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from './utils/useScrollTop';
import { HelmetProvider } from 'react-helmet-async';

// import jwt_decode from 'jwt-decode';
// import  logout  from './store/authActions';
// import { Provider } from 'react-redux';
// import store from './store';

const msalInstance = new PublicClientApplication(msalConfig);
// Check token expiry on page load
// const token = localStorage.getItem('id_token');
// if (token) {
//   const decoded = jwt_decode(token);
//   const currentTime = Date.now() / 1000;
//   if (decoded.exp < currentTime) {
//     store.dispatch(logout());
//   }
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider defer={true}>
      <MsalProvider instance={msalInstance}>
        {/* <Provider store={store}> */}
        <BrowserRouter>
          <ScrollTop />
          <App />
        </BrowserRouter>
      </MsalProvider>
    </HelmetProvider>
  </React.StrictMode>
);


document.addEventListener('DOMContentLoaded', () => {
  const loader = document.getElementById('app-loader');
  if (loader) {
    loader.style.display = 'none';
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
